/* Colors.ts */

export const BASIC_COLORS = [
  "#00b1d3",
  "#00c7c4",
  "#f9a53f",
  "#f87843",
];
